const API_ERROR_MESSAGE = {
    CONTACT_SUPPORT: gettext('Something went wrong. Please contact our support.'),
    DEFAULT_MESSAGE: gettext('Error while updating card with the API.'),
    DONT_HAVE_PERMISSION_MESSAGE: gettext('You do not have permission to change this card.'),
    ERROR_CODE: gettext('Error Code:'),
    NOT_ADMIN: gettext('You must be an admin to execute this action'),
    GOOGLE_EXPRESS_CAMPAIGN: gettext('Could not edit Campaign because it was created by Google Express.'),
    GOOGLE_CAMPAIGN_UPDATE_PERMISSION_DENIED: gettext('Permission Denied. Change your access level in Google Ads Platform from Read Only to Standard to perform this action.'),
    WOOCOMMERCE_INVALID_INFO: gettext('Woocommerce credentials provided is not valid.'),
    ALREADY_SUBSCRIBED: gettext('This team has already subscribed for this plan.'),
    CLIENT_ALREADY_IN_TEAM: gettext('Client already exists in current Team.'),
    CREDIT_CARD_NOT_FOUND: gettext('No credit card was found for this user.'),
    FAILED_CREDIT_CARD_ASSOCIATION: gettext('The association of credit card was failed to the current user.'),
    MULTIPLES_CURRENCIES_NOT_SUPPORTED: gettext('Multiples currencies from account was found, please contact our support.'),
    NO_TEAM_PLAN_FOUND: gettext('No active plan was found for this team. Contact the support.'),
    PAYMENT_PROCESSING_HAS_ALREADY_STARTED: gettext('There is already an order in processing for this action.'),
    PAYMENT_REFUSED: gettext('The payment was refused by the payment processor'),
    PLAN_NOT_FOUND: gettext('Plan does not exist.'),
    PRICE_TOO_LOW: gettext('"The value that is trying to be payed is too low."'),
    USER_NOT_REGISTERED: gettext('User not registered at the Pareto Ads.'),
    USER_CANNOT_ASSOCIATE_ITSELF: gettext('You cannot associate or disassociate yourself.'),
    CANNOT_DISASSOCIATE_TEAM_MEMBER: gettext('You cannot disassociate a team member.'),
    USER_ALREADY_ASSOCIATED: gettext('User already associated.'),
    USER_NOT_ASSOCIATED: gettext('User not associated to be removed.'),
    PIPEDRIVE_API_TOKEN_INVALID: gettext('PipeDrive Api Token is not valid. Please insert a valid one.'),
    CANNOT_DELETE_MASTER_CLIENT: gettext("Can't delete client."),
    USER_NOT_IN_TEAM: gettext("You cannot delete a client which isn't managed by your team."),
    LOJA_INTEGRADA_API_TOKEN_INVALID: gettext('Loja Integrada Api Token is not valid. Please insert a valid one.'),
    INVALID_FILE_NOT_SUPPORTED: gettext('File extension not supported. Try again with another extension.'),
};

const DYNAMIC_API_ERROR_MESSAGE = {
    FACEBOOK_BUDGET_TOO_LOW: message => message.split('.')[0],
    FACEBOOK_USER_DOES_NOT_HAVE_PERMISSION: message => message,
    CANNOT_CONVERT_TO_DAILY_BUDGET: message => message,
    UNAUTHORIZED: message => message,
    COULD_NOT_OPEN_GOOGLE_SHEETS: message => message,
    EMPTY_CELL: message => message,
    ERROR_NOT_MAPPED: message => message,
};

const STRIPE_ERROR = {
    incomplete_cvc: gettext("Your card's security code is incomplete."),
    incomplete_expiry: gettext("Your card's expiration date is incomplete."),
    incomplete_number: gettext('Your card number is incomplete.'),
    invalid_expiry_year_past: gettext("Your card's expiration year is in the past."),
    invalid_expiry_year: gettext("Your card's expiration year is invalid."),
    invalid_number: gettext('Your card number is invalid.'),
};

const INTERFACE_ERROR_MESSAGES = {
    NO_DATA_AVAILABLE: gettext('No data available'),
    INVALID_FIELD_VALUE: gettext('Invalid field(s) value.'),
};

const PROMISE_ERROR_MESSAGES = {
    PROMISE_CANCELLED: gettext('Promise cancelled'),
};

export {
    DYNAMIC_API_ERROR_MESSAGE,
    API_ERROR_MESSAGE,
    INTERFACE_ERROR_MESSAGES,
    PROMISE_ERROR_MESSAGES,
    STRIPE_ERROR,
};
